import React, { useMemo, useState } from "react";
import style from "./index.module.scss";
import ExerciseTopicsButtons from "./components/ExerciseTopicsButtons";
import ExerciseBar from "./components/ExerciseBar";
import { Button } from "antd";
import { AiOutlineLeftCircle, AiOutlineRightCircle } from "react-icons/ai";
import PageRadio from "./components/PageRadio";
import PageCheckBox from "./components/PageCheckBox";
import PageJudge from "./components/PageJudge";
import PageGapFilling from "./components/PageGapFilling";
import DetailLayout from "pages/CourseDetail/components/DetailLayout";
import PageSubjective from "./components/PageSubjective";
import { PaperProps } from "../../../../../API/exercise";
import PageReading from "./components/PageReading";

interface ExerProps {
    data?: PaperProps;
    oneChange: (questionId: string, value: string) => void;
    moreChange: (questionId: string, value: any) => void;
    oneSave: (questionId: string, value: string) => void;
    moreSave: (questionId: string, value: any) => void;
    headerDom: React.ReactNode; //头部组件
}

export default function ExercisePC({
    data,
    oneChange,
    moreChange,
    oneSave,
    moreSave,
    headerDom
}: ExerProps) {
    const [checked, setChecked] = useState(1); //当前选中

    const currentData = useMemo(
        () => data?.topics.find((item, index) => index + 1 === checked),
        [data, checked]
    );

    function pageOneChange(questionId: string, value: string) {
        oneChange(questionId, value);
    }

    function pageMoreChange(questionId: string, value: any) {
        moreChange(questionId, value);
    }

    function pageOneSave(questionId: string, value: string) {
        oneSave(questionId, value);
    }

    function pageMoreSave(questionId: string, value: any) {
        moreSave(questionId, value);
    }

    return (
        <DetailLayout breadcrumb="提交练习">
            {headerDom}
            <ExerciseTopicsButtons
                topicCount={data?.topicCount || "0"}
                totalScore={data?.totalScore || "0"}
            />

            <div className={style.main}>
                <div className={style.left}>
                    {data && (
                        <ExerciseBar
                            checked={checked}
                            data={data.topics}
                            onChange={(val: number) => setChecked(val)}
                        />
                    )}
                </div>

                <div className={style.right}>
                    {currentData &&
                        currentData.queTypeId == "1" &&
                        checked === currentData.index && (
                            <PageRadio
                                data={currentData}
                                oneSave={pageOneSave}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId == "2" &&
                        checked === currentData.index && (
                            <PageCheckBox
                                data={currentData}
                                moreSave={pageMoreSave}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId == "3" &&
                        checked === currentData.index && (
                            <PageJudge
                                data={currentData}
                                oneSave={pageOneSave}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId == "4" &&
                        checked === currentData.index && (
                            <PageSubjective
                                data={currentData}
                                oneSave={pageOneSave}
                                oneChange={pageOneChange}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId == "5" &&
                        checked === currentData.index && (
                            <PageGapFilling
                                data={currentData}
                                moreSave={pageMoreSave}
                                moreChange={pageMoreChange}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId >= "6" &&
                        checked === currentData.index && (
                            <PageReading
                                data={currentData}
                                oneSave={pageOneSave}
                                moreSave={pageMoreSave}
                                oneChange={pageOneChange}
                                moreChange={pageMoreChange}
                            />
                        )}

                    <div className={style.footer}>
                        {currentData && currentData.index !== 1 && (
                            <Button
                                className={style.prev}
                                onClick={() =>
                                    setChecked(currentData.index - 1 || 1)
                                }>
                                <AiOutlineLeftCircle />
                                上一题
                            </Button>
                        )}
                        {currentData &&
                            data &&
                            currentData.index !== data.topics.length && (
                                <Button
                                    className={style.next}
                                    onClick={() =>
                                        setChecked(currentData.index + 1 || 1)
                                    }>
                                    下一题
                                    <AiOutlineRightCircle />
                                </Button>
                            )}
                        {currentData &&
                            data &&
                            currentData.index === data.topics.length && (
                                <div className={style.lastDiv}>
                                    已是最后一题了
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </DetailLayout>
    );
}
